import { format } from 'date-fns'

const sanitize = (value: string): string =>
  value
    .normalize('NFKD')
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '_')

export const buildRunArtefactFilename = (
  run: { name: string; presetKey: string; requestedAt: string },
  ext: string
): string => {
  const base = sanitize(run.name) || sanitize(run.presetKey) || 'report'
  const requested = new Date(run.requestedAt)
  const stamp = Number.isNaN(requested.getTime()) ? '' : `_${format(requested, 'yyyy-MM-dd_HHmm')}`
  return `${base}${stamp}.${ext}`
}
